import { useMemo, ComponentProps } from "react";
import { Link } from "react-router";
import { RevSideBar } from "@revmatics/catalyst";
import { getNavigationData } from "./sideBarData";
import { SideBarLinkType } from "./sideBarDataTypes";
import { IconDefinition } from "@fortawesome/pro-light-svg-icons";
import { useAppSelector } from "../../../../stores/hooks/hooks";

type RevSideBarProps = ComponentProps<typeof RevSideBar>;
type SidebarItem = RevSideBarProps["items"][number];

type Props = {
  open: boolean;
  handleClose: () => void;
};

export const SideBar = ({ open, handleClose }: Props) => {
  const userProfile = useAppSelector((state) => state.profile.profile);
  const brandList = useAppSelector((state) => state.brand.brandList);

  const canManagePlatform = useMemo(() => {
    return (
      userProfile?.roles?.includes("INTERNAL_PLATFORM_CONTENT_MANAGER") ?? false
    );
  }, [userProfile]);

  const mappedItems = useMemo((): SidebarItem[] => {
    const noBrand = brandList && brandList.length === 0;
    const currentNavData = getNavigationData(canManagePlatform, !!noBrand);

    return currentNavData.map((item: SideBarLinkType): SidebarItem => {
      const mappedItem: SidebarItem = {
        id: item.id,
        label: item.title,
        icon: item.icon as IconDefinition,
        pathname: item.link || undefined,
      };

      if (item.children && item.children.length > 0) {
        mappedItem.children = item.children.map((section) => ({
          id: section.id,
          title: section.title,
          links: section.links.map((subLink) => ({
            id: subLink.id,
            label: subLink.title,
            pathname: subLink.link,
          })),
        }));
      }

      return mappedItem;
    });
  }, [brandList, canManagePlatform]);

  return (
    <RevSideBar
      items={mappedItems}
      isOpen={open}
      handleToggle={handleClose}
      linkComponent={Link}
    />
  );
};
